import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = { copyText: String, successMessage: String };

  copy() {
    const text = unescape(this.copyTextValue);

    this.writeToClipboard(text);

    if (this.successMessageValue) {
      toastr.success(this.successMessageValue);
    }
  }

  writeToClipboard(text) {
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text).catch(() => this.fallbackCopy(text));
      return;
    }

    this.fallbackCopy(text);
  }

  fallbackCopy(text) {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'absolute';
    textarea.style.left = '-9999px';
    document.body.appendChild(textarea);
    textarea.select();

    try {
      document.execCommand('copy');
    } catch (error) {
      // Clipboard unavailable; nothing else to do.
    }

    document.body.removeChild(textarea);
  }
}
